module.exports = __webpack_public_path__ + "media/images/icons/outlined/gift-5c1781f5a79f9cd7b4d2ee013792d54e.svg";